module.exports = __webpack_public_path__ + "img/thank-you-card.c207d27d.jpg";